import * as API from "../";
export default {
  // 项目列表
  getList: (params) => {
    return API.POST("/api/third/project/getList", params);
  },
  insert: (params) => {
    return API.postJsonRequest("/api/third/project/add", params);
  },
  getNoBindList: (params) => {
    return API.GET("/api/third/project/getNoBindList" + params);
  },
  delete: (params) => {
    return API.postJsonRequest("/api/third/project/delete/" + params);
  }
};



// WEBPACK FOOTER //
// ./src/api/third/project.js